<template>
  <!-- 数据分析 -->
  <div class="module-info">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="form" class="form" size="small">
        <el-form-item :label="$t('pages.equipment.text52')" style="margin-right:10px;width:650px;">
          <el-date-picker
            v-model="form.startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            :picker-options="pickerOptions0"
            @change="startChange"
          >
          </el-date-picker>
          <span style="margin: 0 14px">-</span>
          <el-date-picker
            v-model="form.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton type="search" @click="getBikeDataAnalysis"></DiluButton>
      </div>
    </div>
    <!-- 图表区域 -->
    <div class="chart">
      <el-row :gutter="20" class="chart-li">
        <el-col :span="12">
          <el-card class="box-card" shadow="never">
            <div id="dilu-speed" style="width: 100%"></div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" shadow="never">
            <div id="dilu-electricity" style="width: 100%"></div>
          </el-card>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="chart-li">
        <el-col :span="12">
          <el-card class="box-card" shadow="never">
            <div id="dilu-voltage" style="width: 100%"></div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" shadow="never">
            <div id="dilu-electricquantity" style="width: 100%"></div>
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="chart-li">
        <el-col :span="12">
          <el-card class="box-card" shadow="never">
            <div id="dilu-mileage" class="charts-li" style="width: 100%"></div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" shadow="never">
            <div id="dilu-network" class="charts-li" style="width: 100%"></div>
          </el-card>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="chart-li">
        <el-col :span="12">
          <el-card class="box-card" shadow="never">
            <div
              id="dilu-satellite"
              class="charts-li"
              style="width: 100%"
            ></div>
          </el-card>
        </el-col>
        <el-col :span="12"> </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
import { resetDate } from "../../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.form.startAt;
        },
        shortcuts: [
          {
            text:this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      form: {
        bikeCode: "", //车辆编码
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
      },
    };
  },
  watch: {
    activeName(newValue) {
      if (newValue == "DataAnalysis") {
        this.form.bikeCode = this.info.bikeCode;
        this.getBikeDataAnalysis();
      }
    },
  },
  props: ["activeName", "info"],
  components: {
    DiluButton,
  },
  mounted() {},
  methods: {
    startChange() {
      this.form.stopAt = null;
    },
    getBikeDataAnalysis() {
      if (this.form.stopAt && this.form.startAt) {
        this.form.stopAt = resetDate(this.form.stopAt); // 结束时间
        this.form.startAt = resetDate(this.form.startAt); // 开始时间
      }
      if (this.form.startAt) {
        if (!this.form.stopAt) {
          return this.$message.error(this.$t("public.text3"));
        }
      }
      if (this.form.stopAt) {
        if (!this.form.startAt) {
          return this.$message.error(this.$t("public.text2"));
        }
      }
      this.request.getBikeDataAnalysis(this.form).then((res) => {
        //速度
        this.speed(res.data.speed);
        //电流
        this.electricity(res.data.electricCurrent);
        //电压
        this.voltage(res.data.batteryVoltage);
        //电量
        this.electricquantity(res.data.batteryPower);
        //里程
        this.mileage(res.data.remainDistance);
        //网络信号
        this.network(res.data.signalIntensity);
        //卫星数量
        this.satellite(res.data.starCount);
      });
    },
    //速度
    speed(e) {
      var chartDom = document.getElementById("dilu-speed");
      var myChart = echarts.init(chartDom);
      var option;
      let date = e.map((i) => {
        return i.x;
      });
      let data = e.map((i) => {
        return i.y;
      });
      option = {
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
        },
        title: {
          left: "left",
          text: this.$t("pages.equipment.text53"),
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
        },
        dataZoom: [
          {
            type: "inside",
            start: 80,
            end: 100,
          },
          {
            start: 80,
            end: 100,
          },
        ],
        series: [
          {
            name: this.$t("pages.equipment.text53"),
            type: "line",
            smooth: 0.6,
            symbol: "none",
            sampling: "lttb",
            itemStyle: {
              color: "rgba(31, 91, 204, 1)",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#1F5BCC",
                },
                {
                  offset: 1,
                  color: "rgba(45, 110, 232, 0)",
                },
              ]),
            },
            data: data,
          },
        ],
      };

      option && myChart.setOption(option);
    },
    //电流
    electricity(e) {
      var chartDom = document.getElementById("dilu-electricity");
      var myChart = echarts.init(chartDom);
      var option;
      let date = e.map((i) => {
        return i.x;
      });
      let data = e.map((i) => {
        return i.y;
      });
      option = {
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
        },
        title: {
          left: "left",
          text: this.$t("pages.equipment.text54") + "(" + "mA" + ")",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
        },
        dataZoom: [
          {
            type: "inside",
            start: 80,
            end: 100,
          },
          {
            start: 80,
            end: 100,
          },
        ],
        series: [
          {
            name: this.$t("pages.equipment.text54") + "(" + "mA" + ")",
            type: "line",
            symbol: "none",
            sampling: "lttb",
            itemStyle: {
              color: "rgba(239, 162, 43, 1)",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#EFA22B",
                },
                {
                  offset: 1,
                  color: "rgba(229, 148, 25, 0)",
                },
              ]),
            },
            data: data,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    //电压
    voltage(e) {
      var chartDom = document.getElementById("dilu-voltage");
      var myChart = echarts.init(chartDom);
      let date = e.map((i) => {
        return i.x;
      });
      let data = e.map((i) => {
        return i.y;
      });
      var option;
      option = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: date,
        },
        title: {
          left: "left",
          text: this.$t("pages.equipment.text55") + "(" + "V" + ")",
        },
        yAxis: {
          type: "value",
          minInterval: 0.5,
        },
        dataZoom: [
          {
            type: "inside",
            start: 80,
            end: 100,
          },
          {
            start: 80,
            end: 100,
          },
        ],
        series: [
          {
            data: data,
            type: "bar",
            showBackground: true,
            itemStyle: {
              color: "rgba(70, 225, 236, 1)",
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    //电量
    electricquantity(e) {
      var chartDom = document.getElementById("dilu-electricquantity");
      var myChart = echarts.init(chartDom);
      let date = e.map((i) => {
        return i.x;
      });
      let data = e.map((i) => {
        return i.y;
      });
      var option;
      option = {
        xAxis: {
          type: "category",
          data: date,
        },
        title: {
          left: "left",
          text: this.$t("pages.equipment.text56") + "(" + "%" + ")",
        },
        yAxis: {
          type: "value",
        },
        dataZoom: [
          {
            type: "inside",
            start: 80,
            end: 100,
          },
          {
            start: 80,
            end: 100,
          },
        ],
        series: [
          {
            data: data,
            type: "bar",
            showBackground: true,
            itemStyle: {
              color: "#1F5BCC",
            },
            emphasis: {
              itemStyle: {
                color: "rgba(31, 91, 204, 1)",
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    //里程
    mileage(e) {
      var chartDom = document.getElementById("dilu-mileage");
      var myChart = echarts.init(chartDom);
      var option;
      let date = e.map((i) => {
        return i.x;
      });
      let data = e.map((i) => {
        return i.y;
      });
      option = {
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
        },
        title: {
          left: "left",
          text: this.$t("pages.equipment.text57"),
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
          minInterval: 0.5,
        },
        dataZoom: [
          {
            type: "inside",
            start: 80,
            end: 100,
          },
          {
            start: 80,
            end: 100,
          },
        ],
        series: [
          {
            name: this.$t("pages.equipment.text57"),
            type: "line",
            smooth: 0.6,
            symbol: "none",
            sampling: "lttb",
            itemStyle: {
              color: "rgba(31, 91, 204, 1)",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#1F5BCC",
                },
                {
                  offset: 1,
                  color: "rgba(45, 110, 232, 0)",
                },
              ]),
            },
            data: data,
          },
        ],
      };

      option && myChart.setOption(option);
    },
    //网络信号
    network(e) {
      var chartDom = document.getElementById("dilu-network");
      var myChart = echarts.init(chartDom);
      var option;
      let date = e.map((i) => {
        return i.x;
      });
      let data = e.map((i) => {
        return i.y;
      });
      option = {
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
        },
        title: {
          left: "left",
          text: this.$t("pages.equipment.text58"),
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
        },
        dataZoom: [
          {
            type: "inside",
            start: 80,
            end: 100,
          },
          {
            start: 80,
            end: 100,
          },
        ],
        series: [
          {
            name: this.$t("pages.equipment.text58"),
            type: "line",
            symbol: "none",
            sampling: "lttb",
            itemStyle: {
              color: "rgba(239, 162, 43, 1)",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#EFA22B",
                },
                {
                  offset: 1,
                  color: "rgba(229, 148, 25, 0)",
                },
              ]),
            },
            data: data,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    //卫星数量
    satellite(e) {
      var chartDom = document.getElementById("dilu-satellite");
      var myChart = echarts.init(chartDom);
      let date = e.map((i) => {
        return i.x;
      });
      let data = e.map((i) => {
        return i.y;
      });
      var option;
      option = {
        xAxis: {
          type: "category",
          data: date,
        },
        title: {
          left: "left",
          text: this.$t("pages.equipment.text59"),
        },
        yAxis: {
          type: "value",
        },
        dataZoom: [
          {
            type: "inside",
            start: 80,
            end: 100,
          },
          {
            start: 80,
            end: 100,
          },
        ],
        series: [
          {
            data: data,
            type: "bar",
            showBackground: true,
            itemStyle: {
              color: "rgba(70, 225, 236, 1)",
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>

<style scoped>
.module-info {
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
}
.searchSubmit {
  float: right;
}
.chart-li {
  margin-bottom: 20px;
}
.box-card {
  height: 335px;
  width: 100%;
}
body .el-card__body {
  height: 100%;
}
.form {
  float: left;
  display: flex;
}
.charts-li {
  height: 295px;
  width: 100%;
}
#dilu-speed {
  height: 295px;
  width: 100%;
}
#dilu-electricity {
  height: 295px;
  width: 100%;
}
#dilu-voltage {
  height: 295px;
  width: 100%;
}
#dilu-electricquantity {
  height: 295px;
  width: 100%;
}
</style>